import { cn } from '@/lib/cn';
import { getRelationFieldNames } from '@/requests/instanceMapper';
import {
  GeneralErrandConfig,
  type GeneralErrand,
} from '@pigello/pigello-matrix';
import Dot from './dot';
import type { RelationFieldProps } from './types';
import { toReadableAddress } from '@/lib/utils';
import { StatusBadge } from '@/components/ui/statusBadge';
export const GeneralErrandItem: RelationFieldProps<GeneralErrand> = {
  nested: getRelationFieldNames(GeneralErrandConfig),
  filters: [],
  renderItem: (item, isRelationField) => ({
    title: item?.idNumber || item.title,
    badge: <StatusBadge type='errand-status' status={item.status} />,
    descriptionItems: (
      <div
        className={cn(
          'flex items-center',
          !isRelationField && 'justify-between'
        )}
      >
        {item.description && (
          <>
            <div className='max-w-72 truncate font-medium'>
              {item?.description}
            </div>
          </>
        )}
        {item.address && !isRelationField && (
          <>
            {item.description && <Dot />}
            <span className='font-medium'>
              {toReadableAddress(item.address, false, false)}
            </span>
          </>
        )}
      </div>
    ),
  }),
};
